exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js?{\"minimize\":true,\"sourceMap\":true}!vue-good-table/dist/vue-good-table.css"), "");

// module
exports.push([module.id, "td[data-v-2010ab4c]{min-height:40px;padding-right:4px;padding-left:4px}", "", {"version":3,"sources":["F:/myugfront/src/pages/online-books.vue"],"names":[],"mappings":"AAEA,oBACE,gBAAiB,AACjB,kBAAmB,AACnB,gBAAkB,CACnB","file":"online-books.vue","sourcesContent":["\n@import '~vue-good-table/dist/vue-good-table.css';\ntd[data-v-2010ab4c] {\n  min-height: 40px;\n  padding-right: 4px;\n  padding-left: 4px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-2010ab4c","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/online-books.vue
// module id = 1152
// module chunks = 0